import { useEffect, useState, useCallback } from 'react'
import { isOnline, processQueue } from '../utils/offline'

interface SyncOptions {
  interval?: number
  onSync?: () => Promise<void>
}

export function useSync({ interval = 60000, onSync }: SyncOptions = {}) {
  const [syncing, setSyncing] = useState(false)
  const [lastSync, setLastSync] = useState<Date | null>(null)

  const sync = useCallback(async () => {
    if (!isOnline() || syncing) return

    setSyncing(true)
    try {
      // 오프라인 큐 처리
      await processQueue()

      // 사용자 정의 동기화
      if (onSync) {
        await onSync()
      }

      setLastSync(new Date())
    } catch (error) {
      console.error('Sync failed:', error)
    } finally {
      setSyncing(false)
    }
  }, [onSync, syncing])

  useEffect(() => {
    // 주기적 동기화
    const syncInterval = setInterval(() => {
      if (isOnline()) {
        sync()
      }
    }, interval)

    // 온라인 상태 변경 시 즉시 동기화
    const handleOnline = () => {
      sync()
    }
    window.addEventListener('online', handleOnline)

    // 초기 동기화
    if (isOnline()) {
      sync()
    }

    return () => {
      clearInterval(syncInterval)
      window.removeEventListener('online', handleOnline)
    }
  }, [interval, sync])

  return { syncing, lastSync, sync }
}

